/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useContext, useEffect, useState } from 'react';
import CompanyService from '../services/companyService';
import { useTranslation } from 'react-i18next';

const CompanyContext = createContext(null);

export const CompanyProvider = ({ children }) => {
    const [business, setBusiness] = useState(null);
    const [loading, setLoading] = useState(true);
    const { i18n } = useTranslation();

    const fetchBusiness = async () => {
        try {
            const lang = i18n.language;
            const data = await CompanyService.fetchOnePublic(lang);
            setBusiness(data);
        } catch (error) {
            console.error('Failed to fetch company data', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBusiness();
    }, []);

    return (
        <CompanyContext.Provider value={{ business, loading, refetch: fetchBusiness }}>
            {children}
        </CompanyContext.Provider>
    );
};

export const useCompany = () => useContext(CompanyContext);
